import React from 'react'
import PropTypes from 'prop-types'

export const GradebookHeaders = ({ activities, coursenum, section }) => {
  if (section === 'left') {
    return (
      <table>
        <tbody>
          <tr>
            <td className="customtable_header customtable_last_name">
              <div className="gradebook_cell">Last Name</div>
            </td>
            <td className="customtable_header customtable_first_name">
              <div className="gradebook_cell">First Name</div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  // Right section
  return (
    <table>
      <tbody>
        <tr>
          <td className="customtable_header customtable_email">
            <div className="gradebook_cell">Email</div>
          </td>
          <td className="customtable_header customtable_signup">
            <div className="gradebook_cell">Signup Date</div>
          </td>
          <td className="customtable_header customtable_section">
            <div className="gradebook_cell">Section</div>
          </td>
          <td className="customtable_header customtable_studentid">
            <div className="gradebook_cell">Student ID</div>
          </td>
          {activities.map(activity => (
            <td
              key={activity.id}
              className="customtable_header customtable_data"
              data-activity-id={`${activity.id}`}
            >
              <div className="gradebook_cell">
                <a href={`/instructor/assessment/${coursenum}/${activity.id}`}>
                  {activity.title}
                </a>
                <br />
                <div className="gradebook_points_possible">
                  {activity.points_possible} points
                </div>
              </div>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  )
}

GradebookHeaders.propTypes = {
  activities: PropTypes.array.isRequired,
  coursenum: PropTypes.string.isRequired,
  section: PropTypes.oneOf(['left', 'right']).isRequired,
}
